import React from 'react';
import styles from '../../styles/formComponent/CommonFooter.module.scss';
import ButtonComponent from '../customButton';

const CommonFooter = ({ 
  buttons = [], 
  className = '', 
  startChildren = null, 
  endChildren = null,
  showStartChildren = false,
  showEndChildren = false,
  ...props 
}) => (
  <div className={`${styles.commonFooter} ${className}`} {...props}>
    {showStartChildren && startChildren && (
      <div className={styles.startChildren}>
        {startChildren}
      </div>
    )}
    
    <div className={styles.buttonsContainer}>
      {buttons.map((button, index) => {
        const key = button.key || index;
        return <ButtonComponent 
          key={key} 
          ctaText={button.label}
          onClick={button.onClick}
          variant={button.variant}
          className={button.className}
          disabled={button.disabled}
          startIcon={button.startIcon}
          endIcon={button.endIcon}
          loading={button.loading}
          type={button.type}
          tooltip={button.tooltip}
        />;
      })}
    </div>

    {showEndChildren && endChildren && (
      <div className={styles.endChildren}>
        {endChildren}
      </div>
    )}
  </div>
);

export default CommonFooter;
